import axios from "axios";
// Entities
import { DataDashboard } from "@/entities/index";

export async function getDailyOrders({
  client,
  warehouse,
  integrateStepZero,
}: {
  client: string;
  warehouse: string;
  integrateStepZero: boolean;
}): Promise<{ dailyOrders: number }> {
  const { dailyOrders } = (
    await axios.post(`/api/dashboards/data`, {
      client,
      warehouse,
      integrateStepZero,
    })
  ).data as DataDashboard;

  return { dailyOrders };
}

export async function getOrderedParts({
  client,
  warehouse,
  integrateStepZero,
}: {
  client: string;
  warehouse: string;
  integrateStepZero: boolean;
}): Promise<{ orderedParts: number }> {
  const { orderedParts } = (
    await axios.post(`/api/dashboards/data`, {
      client,
      warehouse,
      integrateStepZero,
    })
  ).data as DataDashboard;

  return { orderedParts };
}
